// extracted by mini-css-extract-plugin
module.exports = {"products":"_3MJ67X","product":"LeGba_"};